import {SmartComponent} from "smart-component-js";
import GenericModalComponent from "../utils/GenericModalComponent";

class FrequencyMissionModalComponent extends SmartComponent {

    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.modal = new GenericModalComponent(this.element);
        this.exit = this.element.querySelectorAll('.exit a');
        this.mission = this.element.dataset.frequency;

        this.init();
    }

    checkFrequencyMission() {
        if (this.mission === 'true') {
            this.modal.openModal();
        }
    }

    addModalListener() {
        this.exit.forEach((el) => {
            el.addEventListener('click', () => {
                this.modal.closeModal();
            });
        })
    }


    init() {
        this.checkFrequencyMission();
        this.addModalListener();
    }
}

export default FrequencyMissionModalComponent;
